<template>
  <div >
    <div class="row">
      <div class="col-9 col-md-4 col-lg-4 offset-3 offset-md-0 offset-lg-0">
        <img :src="getImage">
      </div>
      <div class="col-12 col-md-8 col-lg-8 mt-3 mt-md-0 mt-lg-0 text-center text-md-left">
        <div>
          <slot name="konfirmTitle" ></slot>
        </div>
        <div class="font-size-10 pt-3">
          <slot name="konfirmContent" ></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components:{
  },
  data(){
    return{
      showKonfirm:"false"
    }
  },
  props: {
    image: {
      type: String,
      default: 'konfirmasi'
    }
  },
  computed: {
    getImage() {
      switch (this.image) {
        case 'error':
        return "assets/loading/surprise-woman.svg";
        default: 
        return "assets/loading/smile-woman.svg";
      }
    },
  },
  methods:{
    konfirmShow(){
      this.showKonfirm = true
    },
    konfirmHide(){
      this.showKonfirm = false
    },
  },
  mounted(){
  }

}
</script>

<style>

</style>